import React from "react"

export default () => {
    return <div class="d-flex justify-content-center" style={{ height: "100vh", alignItems: "center" }}>
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
}